import { useEffect, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { api, apiError, fmtDateTime } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const P = "/studio-portal/central";

export const SendToStudioButton = ({ job }) => {
  const [share, setShare] = useState(null);
  const [open, setOpen] = useState(false);
  const [studios, setStudios] = useState([]);
  const [pick, setPick] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`${P}/jobs/${job.id}/share`).then(({ data }) => setShare(data)).catch(() => {}); }, [job.id]);
  const openDlg = () => {
    setPick(share?.studio_id || job.studio_id || "");
    api.get(`${P}/share-studios`).then(({ data }) => setStudios(data));
    setOpen(true);
  };
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`${P}/jobs/${job.id}/share`, { studio_id: pick });
      setShare(data); setOpen(false); toast.success(`Sent to ${data.studio_name}`);
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <>
      <Button variant="outline" size="sm" data-testid="send-to-studio-btn" onClick={openDlg}>
        <Send className="mr-1.5 h-3.5 w-3.5" />{share?.shared ? `Sent to ${share.studio_name}` : "Send to Studio"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="send-to-studio-dialog">
          <DialogHeader><DialogTitle>Send this job to a studio</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-500">The studio will see the customer, vehicle, services, booked date and price.</p>
          {share?.shared && <p className="text-xs text-slate-500">Last sent to {share.studio_name} by {share.sent_by} · {fmtDateTime(share.sent_at)}</p>}
          <select data-testid="send-to-studio-select" value={pick} onChange={(e) => setPick(e.target.value)}
            className="h-10 w-full rounded-md border border-input bg-white px-3 text-sm">
            <option value="">Choose studio…</option>
            {studios.map((s) => <option key={s.id} value={s.id}>{s.name}{s.district && ` · ${s.district}`}</option>)}
          </select>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button data-testid="send-to-studio-confirm" disabled={!pick || busy} onClick={send} className="bg-crimson-500 hover:bg-crimson-600">Send</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
